














































import { Component } from 'vue-property-decorator';
import SearchTag from './SearchTag.vue';
import { Maybe } from '@/shared/BasicTypes';
import { IFilter } from '@/contract/search.contract';
import FacetSearchBase from './FacetSearchBase.vue';

@Component({ components: { SearchTag } })
export default class FacetSearchMobile extends FacetSearchBase {
  public openFilterCategory: Maybe<string> = null;

  // The filters of the open filtercategory.
  public get shownFilters(): IFilter[] {
    return this.openFilterCategory === null
      ? []
      : this.filters.find((filter) => filter.id === this.openFilterCategory)?.children || [];
  }

  public get noFiltersActive(): boolean {
    return this.filters.every((filterGroup) => filterGroup.children.every((filter) => !filter.isSelected));
  }

  public hasActiveFilter(filterCategory: string): boolean {
    return (
      this.filters.find((filter) => filter.id === filterCategory)?.children?.some((filter) => filter.isSelected) ||
      false
    );
  }

  public toggleFilterDropdown(filter: string) {
    this.openFilterCategory = this.openFilterCategory === filter ? null : filter;
  }

  public closeFilterDropdown() {
    this.openFilterCategory = null;
  }
}
